function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.608 8.01L5.83 13.175a5.894 5.894 0 001.67.248c.68 0 1.345-.124 1.964-.34-.016-.031-.031-.047-.047-.078L7.608 8.01zM1.593 7.5c0 2.335 1.36 4.36 3.325 5.32L2.103 5.088a5.966 5.966 0 00-.51 2.412z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.49 7.206c0-.727-.263-1.237-.48-1.624-.294-.479-.587-.896-.587-1.391 0-.542.417-1.052.99-1.052h.077A5.917 5.917 0 007.5 1.593a5.902 5.902 0 00-4.933 2.66h.386c.62 0 1.578-.078 1.578-.078.325-.015.355.449.03.48l-.68.061 2.15 6.418L7.33 7.253l-.928-2.521a6.446 6.446 0 01-.619-.062c-.324-.015-.278-.51.031-.48 0 0 .975.078 1.562.078.619 0 1.577-.077 1.577-.077.325-.016.356.448.031.48l-.68.061 2.134 6.356.588-1.964c.263-.835.464-1.423.464-1.918zM12.68 4.67c.031.186.047.387.047.603 0 .603-.109 1.268-.449 2.119l-1.809 5.211A5.88 5.88 0 0013.407 7.5a5.789 5.789 0 00-.727-2.83z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0A7.497 7.497 0 000 7.5C0 11.644 3.356 15 7.5 15S15 11.644 15 7.5 11.644 0 7.5 0zm0 14.072C3.881 14.072.928 11.12.928 7.5S3.88.928 7.5.928 14.072 3.88 14.072 7.5 11.12 14.072 7.5 14.072z",
  fill: "#fff"
});

function SvgWordpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgWordpress;